<div class="modal fade" role="dialog"
    (click)="onContainerClicked($event)"
     (keyup)="onKeyPressed($event)"
    [ngClass]="{'in': this.visibleAnimate, 'out': !this.visibleAnimate}"
    [ngStyle]="{'display': this.visible ? 'block' : 'none', 'opacity': this.visibleAnimate ? 1 : 0 }">
    <div class="modal-dialog" [ngClass]="this.customClass">
      <div class="modal-content popup">
        <div class="modal-header" id="modalHeader" #modalHeader>
          <button role="button" type="button" class="modal-close pull-right" aria-label="Close Dialog" [class.hidden]="!showCloseButton"
            (click)="close()" #modalPopup></button>
        </div>
        <div class="modal-body">
          <div #modalbody tabindex="0"></div>
        </div>
      </div>
    </div>
</div>